export default "__VITE_ASSET__CPcKSGev__"